export default __webpack_public_path__ + "static/kim-114dae5879e9688087dd2fae4f3d6802.jpg";